import { httpClient, postProcessDelete } from "@genai/http-client";
import { CollectionId } from "../model";
import { FileId } from "../../file/model";

export function deleteFile(collectionId: CollectionId, fileId: FileId) {
  return httpClient(`/collections/${collectionId}/files/${fileId}`, {
    method: "DELETE",
  }).then(postProcessDelete);
}
